module.exports = __webpack_public_path__ + "img/sprite.b32c8428.png";